import {useProgressBar} from "../Providers/ProgressBar";
import {useEffect} from "react";
import Box from "@mui/material/Box";
import {CircularProgress} from "@mui/material";


export const LazyLoadingSuspense = () => {
    const progressBar = useProgressBar()

    useEffect(() => {
        let p = progressBar.start()

        return () => {
            p.done()
        }
    }, [])
    return <Box display={"grid"} width={"100%"} height={"100%"} sx={{placeItems: 'center'}}>
        <CircularProgress/>
    </Box>
}
